/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { purchaseReturnDetailsApi } from '../api/purchasereturndetails.api';
import { switchMap, map } from 'rxjs/operators';
import { purchaseReturnDetailsData, purchaseReturnDetails } from '../../../interfaces/masters/purchasereturndetails';

@Injectable()
export class purchaseReturnDetailsService extends purchaseReturnDetailsData {

  constructor(private api: purchaseReturnDetailsApi) {
    super();
  }



  list(url: string): Observable<purchaseReturnDetails[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<purchaseReturnDetails>{
      return this.api.getById(url);
  }

  create(url: string, data:purchaseReturnDetails): Observable<purchaseReturnDetails> {
    return this.api.add(url,data);
  }

  update(url: string, data:purchaseReturnDetails): Observable<purchaseReturnDetails> {
   
    return this.api.update(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
